webpackJsonp([25195866457624],{

/***/ 308:
/***/ (function(module, exports) {

	module.exports = {"data":{"hygieia":{"childImageSharp":{"sizes":{"aspectRatio":0.5532144786601837,"src":"/owla-ja-kadonnut-walkia/static/hygieia_dance-10c9a1e44f78a2f7387925695039ae25-dc516.png","srcSet":"/owla-ja-kadonnut-walkia/static/hygieia_dance-10c9a1e44f78a2f7387925695039ae25-2899d.png 128w,\n/owla-ja-kadonnut-walkia/static/hygieia_dance-10c9a1e44f78a2f7387925695039ae25-d42f9.png 256w,\n/owla-ja-kadonnut-walkia/static/hygieia_dance-10c9a1e44f78a2f7387925695039ae25-dc516.png 512w,\n/owla-ja-kadonnut-walkia/static/hygieia_dance-10c9a1e44f78a2f7387925695039ae25-f54c4.png 768w,\n/owla-ja-kadonnut-walkia/static/hygieia_dance-10c9a1e44f78a2f7387925695039ae25-db941.png 1024w","sizes":"(max-width: 512px) 100vw, 512px"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---naytokset-26bf84f48f308b4f297a.js